module.exports = __webpack_public_path__ + "static/media/Pain Management While on Buprenorphine for Opioid Use Disorder 08-22_FINAL.23cc7b6d.pdf";